/**
 * Open a PDF blob in a hidden iframe and trigger the browser print dialog.
 * Used for material labels, transfer receipts, and other 4x6 thermal-label
 * printing flows where we want the operator to land directly in print.
 */
export default function openPdfInPrintDialog(pdfBlob) {
  const blobUrl = URL.createObjectURL(pdfBlob);
  const iframe = document.createElement("iframe");
  iframe.style.display = "none";
  iframe.src = blobUrl;
  document.body.appendChild(iframe);
  iframe.onload = () => {
    setTimeout(() => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
    }, 250);
  };
}
